export default "//cdn.scentbird.com/assets/frontbird-site/images/wipes_e61a8a.png";